<h1 class="text-2xl">{{ "settings.change-language.title" | translate }}</h1>
<form [formGroup]="form" (submit)="submit()">
  <fieldset class="fieldset">
    <legend class="fieldset-legend">
      {{ "settings.change-language.change-language" | translate }}
    </legend>
    <select [formControl]="language" class="select">
      @for (language of supportedLanguages.entries(); track $index) {
        <option [value]="language[0]">{{ language[1] }}</option>
      }
    </select>
  </fieldset>

  <br />
  <button
    type="submit"
    class="btn btn-primary"
    [disabled]="form.invalid || !form.dirty || busy()"
  >
    {{ "common.confirm" | translate }}
  </button>
</form>
